import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MarketplaceProductTarget } from '@/modules/marketplace/products/types/MarketplaceProduct.ts'
import { initialState } from '@/modules/marketplace/products/store/productSlice/initialState.ts'

const productSlice = createSlice({
  name: 'marketplaceProducts',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditTarget: (
      state,
      action: PayloadAction<MarketplaceProductTarget | null>
    ) => {
      state.editTarget = action.payload
    },
    setSponsoredTarget: (
      state,
      action: PayloadAction<MarketplaceProductTarget | null>
    ) => {
      state.sponsoredTarget = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const marketplaceProductActions = productSlice.actions
export const { reducer: marketplaceProductReducer } = productSlice
